import { Link, useLocation } from "react-router-dom";
import { FiInbox, FiKey } from "react-icons/fi";
import { getLeasesHome } from "./constants/leaseRoutes";
import "../property/PropertiesPage.css";
import "../property/components/PropertyPageHeader.css";

/**
 * /customer/shared-leases and /partner/shared-leases
 * The backend has no lease sharing yet (no share endpoint and no "shared with me" list for
 * leases), so this page shows an empty state until that exists.
 */
const SharedLeasesPage = () => {
  const leasesHome = getLeasesHome(useLocation().pathname);
  return (
  <div className="properties-module-page">
    <div className="property-page-header">
      <div className="property-page-header__content">
        <div className="property-page-header__badge">
          <FiKey className="property-page-header__badge-icon" />
          <span>Lease Hub</span>
        </div>
        <h1 className="property-page-header__title">Shared Leases</h1>
        <p className="property-page-header__description">Leases that other people share with you will appear here.</p>
      </div>
    </div>

    <div className="properties-empty-state">
      <div className="properties-empty-state__icon">
        <FiInbox size={48} />
      </div>
      <h3 className="properties-empty-state__title">No shared leases yet</h3>
      <p className="properties-empty-state__text">When someone shares a lease with you, you will find it here.</p>
      <Link to={leasesHome} className="btn btn-outline-primary mt-2">
        Go to My Leases
      </Link>
    </div>
  </div>
  );
};

export default SharedLeasesPage;
